import { csrfToken } from "@/lib/orderActions"
import { cn } from "@/lib/utils"

// A real, full-page HTML form POST to one of the Insider endpoints
// (subscribe = POST /insider, manage = POST /insider/portal). These hit the
// untouched InsiderController Stripe actions, which `redirect_to` the Stripe
// Checkout / Billing Portal on an EXTERNAL host (allow_other_host: true). An
// Inertia `router.post` (XHR) can't follow a cross-origin redirect, so this is a
// genuine browser form submit — the Rails-UJS `button_to` equivalent — carrying
// the CSRF token as the `authenticity_token` field so Rails forgery protection
// passes. The browser then follows the 302 to Stripe.
export default function InsiderPostButton({ action, className, formClassName, tabIndex, children }) {
  return (
    <form action={action} method="post" className={cn("inline-block", formClassName)}>
      <input type="hidden" name="authenticity_token" value={csrfToken()} />
      <button type="submit" className={className} tabIndex={tabIndex}>
        {children}
      </button>
    </form>
  )
}
